"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Radio = _interopRequireDefault(require("./Radio.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Radio = function Radio(_ref) {
  var iconChecked = _ref.iconChecked,
    iconUnchecked = _ref.iconUnchecked,
    textAsIcon = _ref.textAsIcon,
    disabled = _ref.disabled,
    name = _ref.name,
    checked = _ref.checked,
    className = _ref.className,
    onChange = _ref.onChange,
    value = _ref.value,
    id = _ref.id,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    naked = _ref.naked,
    withNativeInput = _ref.withNativeInput;
  var additionalProps = {};
  if (!withNativeInput) {
    additionalProps.onMouseDown = function (ev) {
      ev.stopPropagation();
      onChange(value);
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
    id: id ? "radio-wrapper-".concat(id) : null,
    naked: naked,
    className: "radio-wrapper",
    checked: checked,
    disabled: disabled,
    "aria-label": ariaLabel || name
  }, additionalProps), withNativeInput && /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    id: id,
    value: value,
    name: name,
    disabled: disabled,
    checked: checked,
    className: className,
    onChange: onChange
  }), textAsIcon ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-as-icon"
  }, textAsIcon) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: checked ? iconChecked : iconUnchecked
  }), label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "radio-label"
  }, label));
};
Radio.propTypes = {
  /**
   * Wether the component should use the native checkbox(in certain scenarious onMouseDown needs to be fired)
   * hence this aproach
   */
  withNativeInput: _propTypes["default"].bool,
  /**
   * If `true`, the component will only display the font icon provided
   */
  naked: _propTypes["default"].bool,
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].bool,
  /**
   * The css classes for the checkbox element
   */
  className: _propTypes["default"].string,
  /**
   * The icon string to be used when checked
   */
  iconChecked: _propTypes["default"].string,
  /**
   * The icon string to be used when un-checked
   */
  iconUnchecked: _propTypes["default"].string,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `checkbox` element.
   */
  id: _propTypes["default"].string,
  /*
   * The name attribute of the checkbox element
   */
  name: _propTypes["default"].string,
  /*
   * The aria label for the radio element
   */
  ariaLabel: _propTypes["default"].string,
  /*
   * The label for the radio element
   */
  label: _propTypes["default"].string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,
  /**
   * The value of the component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** If passed, it will replace the Icon component with the custom text */
  textAsIcon: _propTypes["default"].string
};
Radio.defaultProps = {
  withNativeInput: true,
  iconChecked: 'ion-checkmark',
  iconUnchecked: 'ion-checkmark',
  checked: false,
  className: '',
  disabled: false,
  id: '',
  name: '',
  onChange: null,
  value: '',
  ariaLabel: '',
  naked: false,
  label: '',
  textAsIcon: ''
};
Radio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Radio",
  "props": {
    "withNativeInput": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Wether the component should use the native checkbox(in certain scenarious onMouseDown needs to be fired)\r\nhence this aproach",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "iconChecked": {
      "defaultValue": {
        "value": "'ion-checkmark'",
        "computed": false
      },
      "description": "The icon string to be used when checked",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconUnchecked": {
      "defaultValue": {
        "value": "'ion-checkmark'",
        "computed": false
      },
      "description": "The icon string to be used when un-checked",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the component is checked.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The css classes for the checkbox element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the switch will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The id of the `checkbox` element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Callback fired when the state is changed.\r\n\r\n@param {object} event The event source of the callback\r\n@param {boolean} checked The `checked` value of the switch",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The value of the component.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "naked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the component will only display the font icon provided",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "textAsIcon": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "If passed, it will replace the Icon component with the custom text",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Radio);
exports["default"] = _default;